import script from "./OfAddClientModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OfAddClientModal.vue?vue&type=script&setup=true&lang=js"

import "./OfAddClientModal.vue?vue&type=style&index=0&id=40a80de7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a80de7"]])

export default __exports__